module.exports = __webpack_public_path__ + "media/images/area/area_gifuM400-1dc745a2f3fb73eb1d53e5aa060a218a.jpg";